import React, { useMemo } from 'react';
import { Polyline } from 'react-leaflet';

function getGradientColor(progress) {
  let r;
  let g;
  let b;

  if (progress < 0.5) {
    // Yellow-green to orange
    const t = progress / 0.5;
    r = Math.round(170 + (255 - 170) * t);
    g = Math.round(238 + (102 - 238) * t);
    b = 0;
  } else {
    // Orange to deep red
    const t = (progress - 0.5) / 0.5;
    r = Math.round(255 + (187 - 255) * t);
    g = Math.round(102 * (1 - t));
    b = 0;
  }

  return `rgb(${r}, ${g}, ${b})`;
}

const ActivityConnectionLines = ({ mapData, display, user }) => {
  const { showOnlyFirstVisits } = user.mapSettings;

  const activityLines = useMemo(() => {
    if (!mapData || !mapData.geo || !mapData.geo.features) return [];
    if (display.selectedTour === undefined || display.highlightStop === undefined) return [];
    if (display.highlightStop === -1) return [];

    const selectedTour = display.selectedTour;
    const selectedStopIndex = display.highlightStop;

    const stopActivities = [];
    mapData.geo.features.forEach((feature) => {
      if (
        feature.geometry.type === 'Point' &&
        feature.properties.stopLocation &&
        feature.properties.types &&
        feature.properties.routeId === selectedTour &&
        feature.properties.stopIndex === selectedStopIndex
      ) {
        if (showOnlyFirstVisits && !feature.properties.isFirstVisit) return;
        stopActivities.push({
          coordinates: feature.geometry.coordinates,
          activityIndex: feature.properties.activityIndex ?? 0,
          activityOrder: feature.properties.activityOrder ?? 0,
        });
      }
    });

    if (stopActivities.length < 2) return [];

    stopActivities.sort((a, b) => a.activityIndex - b.activityIndex);

    const lines = [];
    for (let i = 0; i < stopActivities.length - 1; i++) {
      const start = stopActivities[i];
      const end = stopActivities[i + 1];

      const progress = stopActivities.length > 2 ? i / (stopActivities.length - 2) : 0;
      const color = getGradientColor(progress);

      lines.push({
        key: `stop-${selectedTour}-${selectedStopIndex}-activity-${i}`,
        positions: [
          [start.coordinates[1], start.coordinates[0]],
          [end.coordinates[1], end.coordinates[0]],
        ],
        color,
      });
    }

    return lines;
  }, [mapData, display.selectedTour, display.highlightStop, showOnlyFirstVisits]);

  if (!activityLines.length) return null;

  return (
    <>
      {activityLines.map((line) => (
        <Polyline
          key={line.key}
          positions={line.positions}
          pathOptions={{
            color: line.color,
            weight: 3,
            opacity: 0.8,
            dashArray: '5, 10',
          }}
        />
      ))}
    </>
  );
};

export default ActivityConnectionLines;
